export default "__VITE_ASSET__D8VylN2e__"